import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getData } from "../../../../backend/api";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const NationalityChart = ({ t }) => {
  const [chartData, setChartData] = useState({ series: [], categories: [] });
  const dispatch = useDispatch();
    const navigate = useNavigate();

  useEffect(() => {
    fetchNationalityData();
  }, []);

  const fetchNationalityData = async () => {
    const date = new Date();
    try {
        const response = await getData({},'user/nationalities-count', dispatch, navigate) // Replace with your actual API
      const { data } = response.data;
    // const data = [
    //     {
    //         "month": 1,
    //         "nationalities": [{
    //             "en": "Austrian",
    //             "de": "österreichisch",
    //             "count": 1
    //         },
    //         {
    //             "en": "Test",
    //             "de": "te",
    //             "count": 4
    //         },
    //         {
    //             "en": "India",
    //             "de": "Ind",
    //             "count": 31
    //         }]
    //     },
    //     {
    //         "month": 2,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 3,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 4,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 5,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 6,
    //         "nationalities": [
    //             {
    //                 "en": "Austrian",
    //                 "de": "österreichisch",
    //                 "count": 10
    //             },
    //             {
    //                 "en": "Test",
    //                 "de": "te",
    //                 "count": 48
    //             },
    //             {
    //                 "en": "India",
    //                 "de": "Ind",
    //                 "count": 5
    //             },
    //             {
    //                 "en": "ok",
    //                 "de": "okay",
    //                 "count": 12
    //             }
    //         ]
    //     },
    //     {
    //         "month": 7,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 8,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 9,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 10,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 11,
    //         "nationalities": []
    //     },
    //     {
    //         "month": 12,
    //         "nationalities": []
    //     }
    // ]

      const monthLabels = [];
      const nationalityMap = {};
      const totals = new Array(12).fill(0);

      // First pass to calculate totals
      data.forEach((monthData) => {
        const { month, nationalities } = monthData;
        totals[month - 1] = nationalities.reduce((acc, nat) => acc + nat.count, 0);
      });

      // Second pass to calculate percentages
      data.forEach((monthData) => {
        const { month, nationalities } = monthData;
        monthLabels.push(`${t(`month-${month}`)} ${date.getFullYear()}`);

        nationalities.forEach((nat) => {
          const natName = sessionStorage.getItem('_lang') 
            ? nat[sessionStorage.getItem('_lang')] || nat.de 
            : nat.de;
          
          if (!nationalityMap[natName]) {
            nationalityMap[natName] = new Array(12).fill(0);
          }
          
          const percentage = totals[month - 1] === 0 
            ? 0 
            : (nat.count / totals[month - 1]) * 100;
          nationalityMap[natName][month - 1] = Number(percentage.toFixed(1));
        });
      });

      setChartData({
        series: Object.keys(nationalityMap).map((key) => ({
          name: key,
          data: nationalityMap[key],
        })),
        categories: monthLabels,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const options = {
    chart: {
      type: "bar",
      stacked: false,
    },
    xaxis: {
      categories: chartData.categories,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        dataLabels: {
          position: "top", // Ensure data labels stay at top 
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function(val, { seriesIndex, w }) {
        // if (val === 0) return "";
        // const seriesName = w.globals.seriesNames[seriesIndex];
        // return `${seriesName} ${val.toFixed(0)}%`;
        return "";
      },
      style: {
        fontSize: "12px",
        colors: ["#ccc"] // Make labels more visible
      }
    },
    colors: ["#1E40AF", "#DC2626", "#16A34A", "#D97706"],
    legend: {
      show: true
    },
  };

  return (
    <div>
      <Chart options={options} series={chartData.series} type="bar" height={300} />
    </div>
  );
};

export default NationalityChart;